<template>
  <div>
    <div class="d-flex justify-space-between">
      <v-btn
        :to="{ name: 'rawProductsCreateUpdate' }"
        class="btn btn-success btn-elevate kt-login__btn-primary text-white"
        >{{ $t("ADD") }} {{ $t("NEW") }}
        {{ $t("RAW_PRODUCT") }}</v-btn
      >
      <v-spacer />
      <v-btn
        class="btn btn-success btn-elevate kt-login__btn-primary text-white"
        :disabled="isLoadingRawProducts"
        @click="openAddFormTypeDialog"
        >{{ $t("ADD_NEW_FORM_TYPE") }}</v-btn
      >
    </div>
    <v-container>
      <v-row no-gutters>
        <v-col cols="4">
          <v-text-field
            v-model="headers.search"
            prepend-inner-icon="search"
            clearable
            :label="$t('SEARCH')"
          ></v-text-field>
        </v-col>

        <v-col cols="6">
        </v-col>

        <v-col class="text-right" cols="2">
          <v-select
            v-model="headers.rows"
            :items="tableOptions.rowsPerPage"
            :label="$t('PER_PAGE')"
            chips
            attach
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="mb-6 t-header">
        <v-col
          v-for="column of headers.columns"
          :key="column.name"
          :cols="column.cols"
        >
          <span @click="changeOrder(column.name)"
            >{{ $t("LABELS." + column.name) }}
            <span v-if="column.name == headers.order">{{
              orderIcon
            }}</span></span
          >
        </v-col>

        <v-col cols="2"> {{ $t("OPERATIONS") }} </v-col>
      </v-row>

      <div v-show="!isLoadingRawProducts">
        <v-row class="mb-6 t-row" v-for="item of items" :key="item.id">
          <v-col
            class="t-col"
            v-for="col of headers.columns"
            :key="col.name"
            :cols="col.cols"
          >
            {{ item[col.name] }}
          </v-col>
          <v-col
            cols="2"
            class="t-col d-flex justify-content-start operation-container flex-wrap"
          >
            <EditButton :id="item.id" action-name="rawProductsCreateUpdate" />
            <LogLink :id="item.id" type="raw-product" />
            <DeleteButton
              :id="item.id"
              :delete-action="deleteAction"
              :fetch-data="fetchData"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col class="text-right">
            {{ totalItems }} {{ $t("RESULTS") }}
          </v-col>
        </v-row>
      </div>

      <v-progress-linear
        class="mt-5"
        color="#25bdad"
        buffer-value="0"
        stream
        reverse
        :active="isLoadingRawProducts"
      ></v-progress-linear>

      <Paginator
        :totalPages="totalPages"
        :page="headers.page"
        :maxVisibleButtons="tableOptions.maxVisibleButtons"
        @change-page="changePage"
      />
      
      <v-dialog v-model="addFormTypeDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            {{ $t("ADD_NEW_FORM_TYPE") }}
          </v-card-title>
          <div
            v-if="
              typeof error_messages === 'object' &&
                Object.keys(error_messages).length > 0
            "
            class="alert alert-danger"
          >
            <ul>
              <template v-for="(error, k) in error_messages">
                <span v-bind:key="k">
                  <li v-for="(message, i) in error" v-bind:key="i">
                    {{ message }}
                  </li>
                </span>
              </template>
            </ul>
          </div>
          <v-card-text>
            <vue-form-generator
              ref="form"
              :model="addFormTypeDialogData"
              :schema="addFormTypeDialogSchema"
            ></vue-form-generator>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="addFormType()"> {{ $t("ADD") }} </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import _ from "lodash";

import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import {
  GET_RAW_PRODUCTS,
  DELETE_RAW_PRODUCT,
  ADD_FORM_TYPE,
} from "@/store/rawProducts.module";
import VueFormGenerator from "vue-form-generator";

import { mapGetters } from "vuex";

import Paginator from "@/components/Paginator";
import LogLink from "@/components/Log/LogLink";
import EditButton from "@/components/ActionButtons/EditButton";
import DeleteButton from "@/components/ActionButtons/DeleteButton";

import ListMixin from "@/common/mixins/List";

export default {
  name: "ListRawProducts",

  components: { LogLink, Paginator, EditButton, DeleteButton, "vue-form-generator": VueFormGenerator.component },
  mixins: [ListMixin],
  data() {
    return {
      addFormTypeDialog: false,
      addFormTypeDialogSchema: {
        fields: [
          {
            type: "input",
            inputType: "text",
            label: this.$t("NAME") + " (BG)",
            model: "name",
            required: true
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("NAME") + " (EN)",
            model: "nameEn",
            required: true
          }
        ]
      },
      error_messages: [],
      addFormTypeDialogData: {
        name: null,
        nameEn: null
      },
      deleteAction: DELETE_RAW_PRODUCT,
      action: "raw_products",
      items: [],
      totalItems: 0,
      headers: {
        columns: [
          {
            name: "id",
            cols: "1",
          },
          {
            name: "name",
            search: "",
            cols: "3",
          },
          {
            name: "strength",
            search: "",
            cols: "",
          },
          {
            name: "primaryQIB",
            search: "",
            cols: "",
          },
          // {
          //     name  : "primaryQuantity",
          //     search: "",
          //     cols  : ""
          // }
        ],
        search: "",
        rows: 10,
        page: 1,
        order: "id",
        orderType: "asc",
      },
    };
  },
  computed: {
    ...mapGetters(["isLoadingRawProducts"]),
    orderIcon: function () {
      let vm = this;

      return vm.headers.orderType == "asc" ? "▲" : "▼";
    },
  },
  watch: {
    "headers.search": _.debounce(function (new_value) {
      let vm = this;

      vm.headers.page = 1;
      if (new_value == null || new_value.length >= 3) {
        vm.fetchData();
      }
    }, 250),
    "headers.rows": _.debounce(function (new_value) {
      let vm = this;
      new_value = parseInt(new_value);
      window.localStorage.setItem(vm.action + "_rows", new_value);

      vm.headers.page = 1;
      vm.fetchData();
    }, 250),
    "headers.page": _.debounce(function () {
      let vm = this;
      vm.fetchData();
    }, 250),
  },
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$t("RAW_PRODUCTS") }]);

    vm.fetchData();
  },
  methods: {
    getOptions: function () {
      let vm = this;

      vm.headers.order =
        window.localStorage.getItem(vm.action + "_order") || "id";
      vm.headers.orderType =
        window.localStorage.getItem(vm.action + "_orderType") || "asc";
      vm.headers.rows = parseInt(
        window.localStorage.getItem(vm.action + "_rows") || 10
      );
    },
    changeOrder: _.debounce(function (key) {
      let vm = this;

      if (vm.headers.order == key) {
        let oType = vm.headers.orderType == "asc" ? "desc" : "asc";

        vm.headers.orderType = oType;
      } else {
        vm.headers.order = key;
      }

      vm.headers.page = 1;
      window.localStorage.setItem(vm.action + "_order", vm.headers.order);
      window.localStorage.setItem(
        vm.action + "_orderType",
        vm.headers.orderType
      );

      vm.fetchData();
    }, 250),
    fetchData: _.debounce(function () {
      let vm = this;

      vm.getOptions();

      vm.$store
        .dispatch(GET_RAW_PRODUCTS, { payload: vm.headers })
        .then((data) => {
          vm.$nextTick(function () {
            vm.items = data.data.data;
            vm.totalItems = data.data.recordsTotal;
            vm.totalPages = data.data.totalPages;
          });
        })
        .catch((response) => {
          if (response.status === 404) {
            vm.$notification["success"]({
              message: response.status,
              description: response.message,
            });
            vm.$router.push({ name: "raw_productsList" });
          }
        });
    }, 500),

    openAddFormTypeDialog() {
      let vm = this;
      vm.addFormTypeDialog = true;
    },
    addFormType() {
      let vm = this;
      vm.error_messages = [];

      let payload = {
        name: vm.addFormTypeDialogData.name,
        nameEn: vm.addFormTypeDialogData.nameEn
      };

      vm.$store.dispatch(ADD_FORM_TYPE, payload).then(data => {
        vm.addFormTypeDialog = false; 
        vm.addFormTypeDialogData.name = null;
        vm.addFormTypeDialogData.nameEn = null;
        vm.error_messages = [];

        vm.$notification["success"]({
          message: this.$t("FORM_TYPE_ADDED_SUCCESSFULLY")
        });
      }).catch(error => {
        vm.error_messages = error.data.errors;
      });
    },
  },

  beforeDestroy: function () {
    this.items = null;
    delete this.items;
  },
};
</script>
